<div class="error-header">
  <a class="navbar-brand d-none d-sm-block UWSlim smaller" href="#">
    {{"uw" | translate}}
  </a>
</div>
<div class="page-container">
  <div class="card" style="width: 40rem;    min-height: 15rem;">
    <div class="card-body" style="text-align: center;padding: 40px;">
      @if (!missing_info) {
        <i class="fas fa-user-lock unauthorized-icon" ></i>
        <h1  class="UWSlim  heading" style="color: #8f0000;">401- {{"error.title_401" | translate}}</h1>
        <h4> {{ errorMessage | translate}} </h4>
      }
      @if (missing_info) {
        <i class="fas fa-exclamation-triangle warning-icon"></i>
        <h1  class="UWSlim heading">{{"error.title_missing" | translate}}</h1>
        <h4> {{ 'error.missing_info' | translate}} </h4>
        @if (missing_info === 'G_P' || missing_info === 'P' ) {
          <span class="missing-field first-field">
            <i class="fas fa-chevron-circle-right" style="margin-right: 6px; color: #c13f3f;"></i>
          {{ 'error.missing_phone_no' | translate}}</span>
        }
        @if (missing_info === 'G_P' || missing_info === 'G' ) {
          <span class="missing-field">
            <i class="fas fa-chevron-circle-right" style="margin-right: 6px; color: #c13f3f;"></i>
          {{ 'error.missing_group' | translate}}</span>
        }
      }
    </div>
  </div>
  <div style="margin-top:10px">
    <a href="{{ 'external_links.legal_url' | translate }}" target="_blank">{{ "footer.legal" | translate }}</a>
    <span class="ml-2 mr-2">|</span>
    <a href="{{ 'external_links.privacy_url' | translate }}" target="_blank">{{ "footer.privacy" | translate }}</a>
    <span class="ml-2 mr-2">|</span>
    <a href="{{ 'external_links.terms_url' | translate }}" target="_blank">{{ "footer.terms" | translate }}</a>
  </div>
</div>
